/* eslint-disable */
document.addEventListener("alpine:init", () => {
    Alpine.data("accordion", (config) => ({
        title: config.title,
        gtmContext: config.gtmContext,
        open: config.open,
        toggle(open) {
            this.open = open;
            let action = this.open ? "expand" : "roll_up"
            this.$dispatch("track-event", {
              "event": "cmp_event",
              "event_type": "accordion",
              "action": action,
              "title": this.title,
              "context": this.gtmContext,
            });

            if (this.open) {
                this.refreshCarousel();
            }
        },
        refreshCarousel() {
            let carousels = this.$root.querySelectorAll(".carousel__wrap");
            let tnsCarousels = window.tnsCarousels || [];
            carousels.forEach(carousel => {
                let targetID = carousel.dataset.uuid;
                let foundCarousel = tnsCarousels.find(tnsCarousel => tnsCarousel.uuid == targetID);
                if (foundCarousel) {
                    foundCarousel.carousel.refresh();
                }
            })    
        }
    }));
});